import i18n from "i18next";
import moment from "moment";
import { sessionLanguage } from "../config";

export const DEFAULT_LOCALE = "en-US";

export const convertLocale = (locale) => {
  if (locale?.length === 2) {
    return `${locale}_${locale.toUpperCase()}`;
  }

  return locale.replace("-", "_");
};

export const getCurrentLocale = () => {
  return sessionStorage.getItem(sessionLanguage) || DEFAULT_LOCALE;
};

export const refreshAppLanguage = () => {
  const locale = getCurrentLocale();

  i18n.changeLanguage(locale);

  if (locale !== DEFAULT_LOCALE) {
    import(`moment/locale/${locale.toLowerCase()}`).then(() => {
      moment.locale(locale.toLowerCase());
    });
  } else {
    moment.locale(locale.toLowerCase());
  }
};

export const checkLanguageAvailability = (code) => {
  const availableLanguages = process.env.REACT_APP_AVAILABLE_LANGUAGES;

  if (
    !availableLanguages ||
    availableLanguages === "all" ||
    availableLanguages === ""
  ) {
    return true;
  }

  return availableLanguages.split(",").includes(code);
};

export const getLanguages = () => [
  {
    id: "en-us",
    code: "en-US",
    value: "English",
    isAvailable: checkLanguageAvailability("en-US"),
  },
  {
    id: "es",
    code: "es",
    value: "Spanish",
    isAvailable: checkLanguageAvailability("es"),
  },
  {
    id: "es-us",
    code: "es-US",
    value: "Spanish US",
    isAvailable: checkLanguageAvailability("es-US"),
  },
  {
    id: "fr",
    code: "fr",
    value: "French",
    isAvailable: checkLanguageAvailability("fr"),
  },
  {
    id: "fr-ca",
    code: "fr-CA",
    value: "French (Canada)",
    isAvailable: checkLanguageAvailability("fr-CA"),
  },
  {
    id: "de",
    code: "de",
    value: "German",
    isAvailable: checkLanguageAvailability("de"),
  },
  {
    id: "it",
    code: "it",
    value: "Italian",
    isAvailable: checkLanguageAvailability("it"),
  },
  {
    id: "nl",
    code: "nl",
    value: "Dutch",
    isAvailable: checkLanguageAvailability("nl"),
  },
];
